import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { MsalHelperService } from '../services/msal-helper.service';
import { PaymentService } from '../services/payment.service';

@Component({
    selector: 'app-permission',
    templateUrl: './permission.component.html',
    styleUrl: './permission.component.scss',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class PermissionComponent implements OnInit {

  public authUrl = '/api/auth';
    @Input() public user$: Observable<any>;
    @Input() public accounts$: Observable<any[]>;
    @Input() public workspace: string;

    constructor(
      private paymentService: PaymentService, 
      private msalHelperService: MsalHelperService, 
      private monitorService: ApiService, 
      private route: ActivatedRoute) { 
    
    }

    ngOnInit(): void {
      this.authUrl = '/api/auth';
    }

    public encodeState(state, cds=null) {
      //const {workspace} = this.license;
  
      let o = {
        "s": state,
        "ws": this.workspace,
        cds,
        "r": `${window.location.href}`
      };
  
      return btoa(JSON.stringify(o));
    }

    public encodeStateParam(state, cds = null): string {
      return encodeURIComponent(this.encodeState(state, cds));
    }

      public getAccountInitials(account: any): string {
        const label = account?.name || account?.unique_name || 'FS';
        return label
          .split(/\s+/)
          .filter(Boolean)
          .slice(0, 2)
          .map((part) => part[0])
          .join('')
          .toUpperCase();
      }

      public getPermissionChips(account: any): string[] {
        const chips: string[] = [];
        if (account?.expires_at) {
          chips.push('Power Automate');
        }
        if (account?.pa_expires_at) {
          chips.push('Power Apps');
        }
        if (account?.error || account?.pa_error) {
          chips.push('Needs attention');
        }
        return chips;
      }

      public hasAnyPermission(account: any): boolean {
        return !!(account?.expires_at || account?.pa_expires_at);
      }
}
